module.exports = __webpack_public_path__ + "img/database.961f034f.png";